import SAPOMailConfig            from "@/SAPOMailConfig";
import HTTPService               from '@/js/Shared/Services/HTTP/HTTPService.js'
import OutOfOfficeOptionsEntity  from '../Collections/OutOfOfficeOptionsItem';

export { OutOfOfficeHTTPService as default };

/**
* Out of office HTTP Service
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class OutOfOfficeHTTPService {
  /**
   * Contacts Enpoint
   *
   * @public
   *
   * @type {string}
   *
   * @since 7.0.0
   */
  endpoint = SAPOMailConfig.client.endpoints.settings.imp;

 /**
   * Calls backend api to fetch out of office settings
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
  async fetchOptions() {
    let response = await HTTPService.post(
      this.endpoint + '/outofofice',
      null,
      'fetch_out_of_office',
    );

    return response;
  }

  /**
   * Calls backend api to add a new person
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {OutOfOfficeOptionsEntity} entity out of office entity
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
  async saveOptions(entity) {
    let request = {
      actionID          : 'update_prefs',
      api               : 1,
      app               : 'imp',
      group             : 'outOfOffice',
      horde_prefs_token : SAPOMailConfig.server.security.settings_token,
      oofActivate       : entity.enabled ? 'on' : 'off',
      oofMsgCust        : entity.message,
      oofMsgType        : 'cust',
      oofStartDate      : entity.date_start,
      oofEndDate        : entity.date_end,
    }

    let response = await HTTPService.post(
      this.endpoint + '/outofofice',
      request,
    );

    return response;
  }
}